import { injectGlobal } from 'styled-components'
import Colors from '../../colors'

injectGlobal`
  .DayPicker__withBorder {
    box-shadow: none;
  }

  .CalendarMonth_table {
    & td {
      border: 1px solid ${Colors.grayD};
    }
  }

  .CalendarMonth_caption {
    padding-bottom: 62px;
    color: ${Colors.black};
    font-size: 16px;
    font-weight: bold;
  }

  .DayPickerNavigation_button__default {
    border: none;
  }

  .DayPickerNavigation_button__default:focus,
  .DayPickerNavigation_button__default:hover {
    border: none;
  }

  .DayPicker_weekHeader_li {
    line-height: 39px;
    border: 1px solid #e4e7e7;
    border-bottom: none;
    color: ${Colors.black};
    font-weight: bold;
    background: ${Colors.grayD};

    &:last-child {
      width: 40px !important;
    }

    &:not(:first-child) {
      border-left: none;
    }
  }

  .DayPicker_weekHeader {
    top: 59px;
  }

  .CalendarDay__selected {
    color: ${Colors.white};
    background: ${Colors.blue};
    border: inherit;
  }

  .CalendarDay_button:hover {
    background: ${Colors.blue};
    color: ${Colors.white};
  }

  .CalendarMonth_table td {
    border: 1px solid ${Colors.grayD};
  }

  .DayPickerNavigation_svg__horizontal {
    fill: ${Colors.blue};
  }

  .CalendarDay__selected_span {
    background: ${Colors.blue};
    color: ${Colors.white};
  }

  .CalendarDay__selected_span:active,
  .CalendarDay__selected_span:hover {
    background: ${Colors.blue};
    border: 1px solid ${Colors.grayD};
  }

  .CalendarDay__selected:hover {
    background: ${Colors.blue};
    color: ${Colors.white};
    border: inherit;
  }

  .CalendarDay__selected:active {
    background: ${Colors.blue};
    color: ${Colors.white};
    border: inherit;
  }

  .CalendarDay {
    vertical-align: middle;
  }

  .ant-calendar-picker {
    display: block;
  }
  .ant-calendar-picker-input {
    height: 40px;
    border-color: #b3b3b3;
  }
  .ant-calendar-picker-icon:after {
    font-family: 'fonts' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    content: "\\e92d";
    color: ${Colors.blue};
  }
  .anticon-close-circle:before, .anticon-cross-circle:before {
    content: "\\0d7";
    position: inherit;
    top: -2px;
  }
  .ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
    border-color: ${Colors.blue};
  }
  .ant-calendar-picker-clear {
    margin-right: 0;
  }
`



// WEBPACK FOOTER //
// ./src/components/styles/extra/ant-design/day-picker.js